import { render, staticRenderFns } from "./financialLiteracy.vue?vue&type=template&id=321db125"
import script from "./financialLiteracy.vue?vue&type=script&lang=js"
export * from "./financialLiteracy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports